export const baseUrl = "https://upwardiqprism.com/api";
// export const baseUrl = "http://localhost:8081/api";

const getAccessToken = () => {
  let token = JSON.parse(localStorage.getItem("token"));
  return token ? token : "";
};

export const loginApi = async (obj) => {
  let res = await fetch(baseUrl + "/login", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE",
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const changePassword = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/changePassword", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const forgotPassword = async (obj) => {
  let res = await fetch(baseUrl + "/forgotPassword", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Import Data File upload FOR ofac tab and non sdn tab
export const importOfacSdnandnonSdn = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importOfacSdnandnonSdn", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Import Data uploaded file view
export const getImportedFileData = async ({
  file_type,
  bank_code,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();

  let res = await fetch(
    `${baseUrl}/getImportedfileData/${file_type}/${bank_code}?page=${page}&pageSize=${pageSize}`,
    {
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      method: "GET",
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllImportedHistoryFileData = async ({
  file_type,
  bank_code,
}) => {
  let accessToken = await getAccessToken();

  let res = await fetch(
    `${baseUrl}/getAllImportedHistoryFileData/${file_type}/${bank_code}`,
    {
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      method: "GET",
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Import Data uploaded file view
export const getImportedData = async ({
  file_type,
  file_name,
  bank_code,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();

  let res = await fetch(
    `${baseUrl}/getImportedData/${file_type}/${file_name}/${bank_code}`,
    {
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      method: "GET",
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For File upload address
export const importWatchList = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importWatchList", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For File upload address
export const importPEP = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importPEP", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For File upload address
export const importAddress = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importAddress", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For File upload Uk sanctions
export const importUkSanctions = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importUkSanctions", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For File upload Uk sanctions
export const importOthers = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importOthers", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Reference Data Abbreviations import
export const importAbbreviations = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importAbbreviations", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createAbbreviations = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createAbbreviations", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveAbbreviations = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveAbbreviations", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveAbbreviations = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveAbbreviations", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAbbreviationsInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAbbreviationsInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const updateAbbreviation = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editAbbreviations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteAbbreviation = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteAbbreviation/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Reference Data Anglicized import
export const importAnglicized = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importAnglicized", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createAnglicized = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createAnglicized", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveAnglicized = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveAnglicized", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveAnglicized = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveAnglicized", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAnglicizedInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAnglicizedInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editAnglicized = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editAnglicized`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteAnglicized = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteAnglicized/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Reference Data Alias import
export const importAlias = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importAlias", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createAlias = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createAlias", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveAlias = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveAlias", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveAlias = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveAlias", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAliasInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAliasInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editAlias = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editAlias`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteAlias = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteAlias/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Reference Data BadData
export const importBadData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importBadData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createBadData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createBadData", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveBadData = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveBadData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveBadData = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveBadData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getBadDataInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getBadDataInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const updateBadData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editBadData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteBadData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteBadData/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Double Letters
export const importSingleDouble = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importSingleDouble", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createSingleDouble = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createSingleDouble", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveSingleDouble = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveSingleDouble", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveSingleDouble = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveSingleDouble", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getSingledoubleInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getSingledoubleInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editSingleDouble = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editSingleDouble`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteSingledouble = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteSingledouble/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Intervening
export const importIntervening = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importInterveningData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createIntervening = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createIntervening", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveInterveningData = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveInterveningData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveIntervening = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveInterveningData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getInterveningInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getInterveningDataInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const updateIntervening = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editInterveningData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteIntervening = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteInterveningData/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For NickNames
export const importNickNames = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importNickNames", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createNickNames = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createNickNames", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveNicknames = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveNicknames", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveNicknames = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveNicknames", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getNicknameInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getNicknameInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editNickname = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editNickname`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteNickname = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteNickname/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Initials
export const importInitials = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importInitials", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createInitials = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createInitials", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveInitials = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveInitials", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveInitials = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveInitials", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getInitialInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getInitialInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editInitials = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editInitials`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteInitial = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteInitial/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For Countries
export const importCountriesData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importCountriesData", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createCountry = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createCountry", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllActiveCountries = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllActiveCountries", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getAllInActiveCountries = async () => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getAllInActiveCountries", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const getCountryInfo = async (record_id) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/getCountryInfo/" + record_id, {
    headers: {
      "x-access-token": accessToken,
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const editCountryData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/editCountryData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const deleteCountry = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(
    `${baseUrl}/deleteCountry/${obj.record_id}/${obj.correl_id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
      body: JSON.stringify(obj),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// Delete multiple reference data records (select_all or list of ids)
export const deleteMultipleReferenceData = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(`${baseUrl}/deleteMultipleReferenceData`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For MT202 File upload
export const importMT202 = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importMT202", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// Data processing
// For getting processed data with pagination
export const getProcessedData = async ({
  processed_id,
  correl_id,
  file_type,
  bank_code,
  page,
  pageSize,
  file_name,
  scenario,
  output_filename,
  scenarios,
  search,
}) => {
  let accessToken = await getAccessToken();

  const res = await fetch(`${baseUrl}/getProcessedData`, {
    method: "POST",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      processed_id,
      correl_id,
      file_type,
      bank_code,
      file_name,
      scenario,
      output_filename,
      scenarios,
      search,
    }),
  });

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For getting top three history file data
export const getTopThreeHistoryFileData = async ({ file_type, bank_code }) => {
  let accessToken = await getAccessToken();

  const res = await fetch(
    `${baseUrl}/getTopThreeHistoryFileData/${file_type}/${bank_code}`,
    {
      method: "GET",
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
    }
  );

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// All Scenario Api
export const AllOtherFilesScenario = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/AllOtherFilesScenario", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// OFAC Scenario API
export const OfacScenario = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/OfacScenario", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// To getScenarioType
export const getScenarioType = async () => {
  let accessToken = await getAccessToken();

  let res = await fetch(`${baseUrl}/getScenarioType`, {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// To getsenarios based on scenarioTypes
export const getScenarioList = async ({ scenario_type }) => {
  let accessToken = await getAccessToken();

  let res = await fetch(`${baseUrl}/getScenarioList/${scenario_type}`, {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "GET",
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
export const getFilesByProcessId = async ({
  processed_id,
  correl_id,
  file_type,
  bank_code,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();

  const res = await fetch(`${baseUrl}/getFilesByProcessId`, {
    method: "POST",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      processed_id,
      correl_id,
      file_type,
      bank_code,
    }),
  });

  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For Pep, greylist, whitelist, negative cases and Pc-lfm use OthersScenario
export const OthersScenario = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/OthersScenario", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
export const UKSanctionsScenario = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/UKSanctionsScenario", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(obj),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// For View Files in data Processing
// For Import Data uploaded file view
export const getImportedHistoryFileData = async ({
  file_type,
  bank_code,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();

  let res = await fetch(
    `${baseUrl}/getImportedHistoryFileData/${file_type}/${bank_code}?page=${page}&pageSize=${pageSize}`,
    {
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      method: "GET",
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
export const deleteProcessedData = async ({
  file_type,
  file_name,
  bank_code,
  correl_id,
  scenario,
  processed_id,
}) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/deleteProcessedData", {
    method: "DELETE",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file_type,
      file_name,
      bank_code,
      correl_id,
      scenario,
      processed_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// Delete Imported Data
export const deleteImportedFileData = async ({
  file_type,
  file_name,
  bank_code,
  correl_id,
}) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/deleteImportedFileData", {
    method: "DELETE",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file_type,
      file_name,
      bank_code,
      correl_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For getting all the processed data
export const getSelectionViewSummary = async ({
  correl_id,
  bank_code,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();
  const res = await fetch(
    `${baseUrl}/getSelectionViewSummary?page=${page}&pageSize=${pageSize}`,
    {
      method: "POST",
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        correl_id,
        bank_code,
      }),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For applying data selection and getting combination_id
export const getSelectedScenarioData = async ({
  output_filename,
  bank_code,
  correl_id,
  range_selection,
  processed_id,
}) => {
  let accessToken = await getAccessToken();
  const res = await fetch(`${baseUrl}/getSelectedScenarioData`, {
    method: "POST",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      output_filename,
      bank_code,
      correl_id,
      range_selection,
      processed_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
// Save combination data
// This function saves the combination data after selection
export const saveCombination = async ({
  output_filename,
  file_type,
  scenario,
  record_count,
  bank_code,
  correl_id,
  processed_id,
}) => {
  let accessToken = await getAccessToken();
  const res = await fetch(`${baseUrl}/saveCombination`, {
    method: "POST",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      output_filename,
      file_type,
      scenario,
      record_count,
      bank_code,
      correl_id,
      processed_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For generating NONGHYUP bank file
export const generateNONGHYUPfile = async (combination_id) => {
  let accessToken = await getAccessToken();
  const res = await fetch(`${baseUrl}/generateNONGHYUPfile/${combination_id}`, {
    method: "POST",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For getting selection data by scenario
export const getSelectionDataByScenario = async ({
  bank_code,
  correl_id,
  scenario,
  output_filename,
  combination_id,
  page,
  pageSize,
}) => {
  let accessToken = await getAccessToken();
  const res = await fetch(
    `${baseUrl}/getSelectionDataByScenario?page=${page}&pageSize=${pageSize}`,
    {
      method: "POST",
      headers: {
        "x-access-token": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        bank_code,
        correl_id,
        scenario,
        output_filename,
        combination_id,
      }),
    }
  );
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For deleting selected scenario data
export const deleteSelectedScenarioData = async ({
  output_filename,
  bank_code,
  correl_id,
  scenario,
  combination_id,
}) => {
  let accessToken = await getAccessToken();
  const res = await fetch(`${baseUrl}/deleteSelectedScenarioData`, {
    method: "DELETE",
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      output_filename,
      bank_code,
      correl_id,
      scenario,
      combination_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

export const createWatchList = async ({ name, bank_code, correl_id }) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createWatchList", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      name,
      bank_code,
      correl_id,
    }),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
export const createImport = async (payload) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/createImport", {
    headers: {
      "x-access-token": accessToken,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For importing violations
export const importViolations = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importViolations", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};

// For importing detections
export const importDetections = async (obj) => {
  let accessToken = await getAccessToken();
  let res = await fetch(baseUrl + "/importDetections", {
    headers: {
      "x-access-token": accessToken,
    },
    method: "POST",
    body: obj,
  });
  if (!res.ok) {
    let data = await res.json();
    data.status = "F";
    data.apiStatus = res.status;
    console.log(data);
    return data;
  }
  let data = await res.json();
  return data;
};
